import { FC } from 'react';

import { Card, Checkbox, Divider, Flex, Skeleton, Switch, TableBody, TableCell, TableRow } from '@hh.ru/magritte-ui';
import { EllipsisHorizontalOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import {
    CAMPAIGNS_TABLE_COLUMNS_MAP,
    CampaignsTableColumn,
} from 'components/CampaignsDashboard/components/CampaignsTable/columns';
import { getCampaignsTableColumns } from 'components/CampaignsDashboard/utils/utils';

import { useSelector } from 'store/utils';

const SKELETON_ROWS = [0, 1, 2];

const TableSkeletonElement: FC<{ width?: number }> = ({ width = 60 }) => {
    return <Skeleton loading height={16} width={width} borderRadius={4} />;
};

export const CampaignsTableSkeleton: FC = () => {
    const columnsPreset = useSelector((state) => state.campaignsFilters.columnsPreset);
    const columns = getCampaignsTableColumns(columnsPreset);

    const rowContent = (
        <>
            {columns.map((columnKey) => {
                const { width, stickyLeft } = CAMPAIGNS_TABLE_COLUMNS_MAP[columnKey];

                const getContent = () => {
                    if (columnKey === CampaignsTableColumn.Actions) {
                        return (
                            <Card padding={0} style="primary" borderRadius={8} borderWidth="default">
                                <Flex p={4}>
                                    <Checkbox checked={false} disabled />
                                </Flex>
                                <Divider />
                                <EllipsisHorizontalOutlinedSize24 padding={4} initialColor="tertiary" />
                            </Card>
                        );
                    }

                    if (columnKey === CampaignsTableColumn.Switch) {
                        return <Switch checked={false} disabled />;
                    }

                    if (columnKey === CampaignsTableColumn.CampaignName) {
                        return (
                            <Flex direction="column" gap={6}>
                                <TableSkeletonElement width={220} />
                                <TableSkeletonElement width={110} />
                                <TableSkeletonElement />
                            </Flex>
                        );
                    }

                    return <TableSkeletonElement />;
                };

                return (
                    <TableCell key={columnKey} width={width} stickyLeft={stickyLeft}>
                        {getContent()}
                    </TableCell>
                );
            })}
        </>
    );

    return (
        <TableBody data-qa="campaigns-table-skeleton">
            {SKELETON_ROWS.map((rowIndex) => (
                <TableRow verticalAlign="middle" key={rowIndex}>
                    {rowContent}
                </TableRow>
            ))}
        </TableBody>
    );
};
